import { render, staticRenderFns } from "./appointView.vue?vue&type=template&id=6bbff4ee&scoped=true"
import script from "./appointView.vue?vue&type=script&lang=js"
export * from "./appointView.vue?vue&type=script&lang=js"
import style0 from "./appointView.vue?vue&type=style&index=0&id=6bbff4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbff4ee",
  null
  
)

export default component.exports